export { default } from "./createStyled.js";
export * from "./createStyled.js";